/**
 * playerErrorModal.tsx
 */
import Buttons from '../../elements/modal/playerErrorModalButtons';
import ChannelDown from '../../elements/images/channelDown';
import ChannelUp from '../../elements/images/channelUp';
import Container from '../../atoms/container/modalContainer';
import Error from '../../atoms/container/errorContainer';
import Logo from '../../atoms/images/modalLogo';
import Subtitle from '../../atoms/text/modalSubtitle';
import Title from '../../atoms/text/modalTitle';
import TranslationManager from '@shared/assets/locale/translationsManager';
import { channelsSelector } from '@shared/store/slices/channels.slice';
import { mediaSelector } from '@shared/store/slices/media.slice';
import { useAppSelector } from '@shared/store/hooks';
import { CompatibilityError } from '@shared/types/enums/player';
import DeviceConfig from '@devices/config';

/**
 * Displays the player error modal.
 */
export default function PlayerErrorModal() {
  const { currentChannel } = useAppSelector(channelsSelector);
  const { error, live } = useAppSelector(mediaSelector);
  const { code, detail, message, player, type } = error || {};
  const showCompatibilityError =
    currentChannel?.avplay &&
    DeviceConfig.capabilities.minimumCBCSVersion &&
    parseFloat(DeviceConfig.info.version as unknown as string) <
      DeviceConfig.capabilities.minimumCBCSVersion;
  let subtitleText = '';
  if (showCompatibilityError)
    subtitleText =
      CompatibilityError[TranslationManager.currentLanguage as 'es'];
  else {
    subtitleText = detail
      ? TranslationManager.get(
          'MODAL.PLAYER_ERROR.SUBTITLE_DETAIL',
          type,
          detail,
          player
        )
      : TranslationManager.get(
          'MODAL.PLAYER_ERROR.SUBTITLE_CODE',
          TranslationManager.get(type || ''),
          code,
          player
        );
  }
  return (
    <Container>
      {live ? <ChannelUp /> : null}
      <Error>
        <Title>{TranslationManager.get('MODAL.PLAYER_ERROR.TITLE')}</Title>
        {player && (code || detail) ? (
          <Subtitle>{subtitleText}</Subtitle>
        ) : null}
        {message ? <Subtitle>{message}</Subtitle> : null}
        {live ? (
          <Logo key={currentChannel?.id} src={currentChannel?.logo} />
        ) : null}
        {!showCompatibilityError ? <Buttons /> : null}
      </Error>
      {live ? <ChannelDown /> : null}
    </Container>
  );
}
